// Unified State License Service - switches between API and DynamoDB based on environment
import interpreterLicensureService from './interpreterLicensureService';
// TODO: Create apiStateLicenseService when API endpoints are available

// Environment-based service selection:
// All environments now use API Gateway
const USE_API = true;

// Log configuration only in development
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 State License Service Configuration:', {
    USE_API,
    service: USE_API ? 'API' : 'DynamoDB',
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'server'
  });
}

// Service selector - for now, always use DynamoDB until API endpoints are created
const getService = () => {
  // TODO: Implement API service when state license endpoints are available
  // return USE_API ? apiStateLicenseService : interpreterLicensureService;
  return interpreterLicensureService;
};

// Unified interface
export const stateLicenseService = {
  async getAllStateRequirements() {
    const service = getService();
    return service.getAllStateRequirements();
  },

  async getStateRequirements(state) {
    const service = getService();
    return service.getStateRequirements(state);
  },

  async getUserStateLicenses(userId) {
    const service = getService();
    return await service.getUserStateLicenses(userId);
  },

  async addUserStateLicense(userId, licenseData) {
    const service = getService();
    return await service.addUserStateLicense(userId, licenseData);
  },

  async updateUserStateLicense(licenseId, updates) {
    const service = getService();
    return await service.updateUserStateLicense(licenseId, updates);
  },

  async deleteUserStateLicense(licenseId) {
    const service = getService();
    return await service.deleteUserStateLicense(licenseId);
  },

  async calculateStateLicenseProgress(userCEUs, stateLicense) {
    const service = getService();
    return service.calculateStateLicenseProgress(userCEUs, stateLicense);
  }
};

export default stateLicenseService;